<template>
  <div>
    <el-card shadow="never"
             class="mb10">

    </el-card>
    <el-card shadow="never">
      列表
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'user-data',
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style>
.test-div {
  background-color: blanchedalmond;
  border-radius: 25px;
  border: 1px solid black;
  height: 200px;
  width: 400px;
}
</style>